import React from "react";
import Hero from "./components/Hero";

const details = [
    {
        "template": "coupons",
        "steps": [
            {
                "name": "Choose Your Style",
                "description": "Select a personalized, printable coupon template that fits your needs, whether it's for fun, relaxation, or a special occasion."
            },
            {
                "name": "Personalize Your Coupons",
                "description": "Add your own messages and custom details to each coupon to make them unique."
            },
            {
                "name": "Download & Print",
                "description": "Once your coupons are ready, download them instantly and print them out."
            }
        ],
        "styles": [
            {
                "title": "Minimal",
                "description": "A clean, simple coupon design with subtle colors, focusing on clarity and easy readability."
            },
            {
                "title": "Playful",
                "description": "A fun, colorful coupon design with vibrant accents to grab attention and create a lively feel."
            },
            {
                "title": "Romantic",
                "description": "A soft, elegant coupon style with warm tones and delicate details, perfect for special occasions."
            },
            {
                "title": "Luxury",
                "description": "A sophisticated coupon design with rich colors and refined accents, conveying a premium look and feel."
            }
        ]
    },
    {
        "template": "invoices",
        "steps": [
            {
                "name": "Select an Invoice Template",
                "description": "Choose a professional, customizable invoice template designed for your business needs."
            },
            {
                "name": "Add Invoice Details",
                "description": "Edit client info, dates, and line items directly in the template to create personalized, ready-to-use invoices."
            },
            {
                "name": "Download or Print",
                "description": "Download your personalized invoices as printable files or PDFs, ready to send or archive."
            }
        ],
        "styles": [
            {
                "title": "Clean",
                "description": "A minimalist invoice layout, focused on clear structure and essential billing details."
            },
            {
                "title": "Branded",
                "description": "A clean invoice layout with a dedicated logo area, allowing you to showcase your brand identity."
            }
        ]
    },
    {
        "template": "landingPages",
        "steps": [
            {
                "name": "Choose a Landing Page Template",
                "description": "Select a customizable static landing page template designed for promotions, events, personal projects, or business showcases."
            },
            {
                "name": "Personalize Your Content",
                "description": "Customize headlines, text, colors, images, and buttons to reflect your brand and create a unique landing page experience."
            },
            {
                "name": "Download Your Landing Page",
                "description": "Click the download button to generate a zipped file of your site. Unzip the file to access your project."
            },
            {
                "name": "Generate Favicon and Icons",
                "description": "Use https://favicon.io to generate your favicon and platform-specific icons. Do not rename the files. Download the generated zip, unzip it, and move all files into the folder you unzipped in the previous step."
            }, {
                "name": "Upload to Hosting Site",
                "description": "Your landing page is ready to go live. Simply upload your project folder to a hosting provider like Netlify using drag-and-drop, or use any hosting platform you prefer."
            }
        ],
        "styles": [
            {
                "title": "Simple",
                "description": "A clean, minimal layout focused on clarity and readability. Perfect for email campaigns, lead generation, business introductions, and service overviews."
            },
            {
                "title": "Shop",
                "description": "A clean product-focused layout designed for selling items or services with fixed pricing. Includes clear product listings, pricing, and simple ordering."
            },
            // {
            //     "title": "Showcase",
            //     "description": "Designed to highlight your work, products, or services in a visually stunning way. Perfect for Portfolios, Product/service listings, Case studies or client testimonials."
            // }
        ]
    }
];

const Home = () => {
    const [activeTab, setActiveTab] = React.useState("coupons");

    return (
        <div style={{ width: "100%" }}>
            <Hero />
            <section className="projects">
                <div className="container">
                    <div className="projects-header">
                        <h2 style={{ color: "#6F8ABF" }}>Featured Templates</h2>
                        <div className="filters">
                            <ul className="nav nav-tabs" role="tablist">
                                {["coupons", "invoices", "landingPages"].map((template, i) => (
                                    <li key={i} className="nav-item" role="presentation">
                                        <button
                                            className={`filter-btn ${activeTab === template ? "active" : ""}`}
                                            onClick={() => setActiveTab(template)}>
                                            {template === "invoices"
                                                ? "PROFESSIONAL INVOICES" : template.includes("Pages")
                                                    ? "LANDING PAGES" : template.toUpperCase()}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="projects-grid">
                        <div className="tab-content">
                            <div style={{ textAlign: "left" }} className="tab-pane fade show active container-fluid">
                                {details.filter(d => d.template === activeTab).map((d, i) => (
                                    <div key={i}>
                                        {d.steps.map((step, j) => (
                                            <div key={j} className="mb-3">
                                                <h4 style={{
                                                    background: "linear-gradient(90deg, #c93a3a, #6F8ABF)",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent"
                                                }} className="card-title fw-bold">STEP {j + 1}: {step.name}</h4>
                                                <p className="card-text lineClamp1">{step.description}</p>
                                            </div>
                                        ))}
                                        <h4 style={{ textDecoration: "underline" }} className="card-title fw-bold">Available Styles</h4>
                                        <ul>
                                            {d.styles.map((style, i) => (
                                                <li key={i} className="card-text lineClamp1">
                                                    <span style={{
                                                        color: "#c93a3a",
                                                        textDecoration: "underline",
                                                        fontWeight: "bolder"
                                                    }}>{style.title}:</span>&nbsp;{style.description}
                                                </li>
                                            ))}
                                        </ul>

                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="project-card" onClick={() => window.location.href = `/${activeTab}`}>
                            <img src={`/images/${activeTab}.png`} alt={`${activeTab} template example`} />
                            <div className="project-overlay">
                                <div className="tags">
                                    <span className="tag">{activeTab === "coupons" ? "Create Your Personalized Coupons Now!"
                                        : activeTab === "invoices" ? "Create a Professional Invoice Now!"
                                            : "Create a Landing Page Now!"}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="stats">
                <div className="container">
                    <div className="stats-grid">
                        <div className="stat">
                            <h2>{details.length}+</h2>
                            <p>Templates</p>
                        </div>
                        <div className="stat">
                            <h2>50+</h2>
                            <p>Downloads</p>
                        </div>
                        <div className="stat">
                            <h2>{details.reduce((a, c) => c.styles.length + a, 0)}+</h2>
                            <p>Styles</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home;